import '@babel/polyfill';
import svg4everybody from 'svg4everybody';

require('ninelines-ua-parser');

svg4everybody();
